'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLoop = function MdLoop(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 30v-5l6.6 6.6-6.6 6.8v-5q-5.5 0-9.4-4t-4-9.4q0-3.9 2.2-7.1l2.4 2.4q-1.2 2.1-1.2 4.7 0 4.1 2.9 7.1t7.1 2.9z m0-23.4q5.5 0 9.4 4t4 9.4q0 3.9-2.2 7.1l-2.4-2.4q1.2-2.1 1.2-4.7 0-4.1-2.9-7.1t-7.1-2.9v5l-6.6-6.6 6.6-6.8v5z' })
        )
    );
};

exports.default = MdLoop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/loop.js
// module id = 1213
// module chunks = 36573943044255 79611799117203 213534597649335